import { Routes } from '@angular/router';

export default [
  {
    path: 'login',
    loadComponent: () => import('./pages/login').then((c) => c.Login),
  },
  {
    path: 'logout',
    loadComponent: () => import('./pages/logout').then((c) => c.Logout),
  },
  {
    path: 'callback',
    loadComponent: () => import('./pages/callback/callback').then((c) => c.Callback),
  },
  {
    path: 'accessdenied',
    loadComponent: () => import('./pages/accessdenied').then((c) => c.AccessDenied),
  },
] as Routes;
